module.exports = __webpack_public_path__ + "static/img/without_bg_h5.db07329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/without_bg_h5.png
// module id = 9Zpl
// module chunks = 34